import { Component, inject, signal } from '@angular/core';
import { PageComponent } from '../../../infrastructure/shared/components/page/page';
import { ClientsClient, ClientStatsResponse } from '../../../infrastructure/shared/model/fss.api';
import { firstValueFrom } from 'rxjs';
import { Users01 } from '../../../infrastructure/shared/icons/users-01/users-01';
import { Building05 } from '../../../infrastructure/shared/icons/building-05/building-05';
import { UserCircle } from '../../../infrastructure/shared/icons/user-circle/user-circle';
import { AdminClientsTable } from '../admin-clients-table/admin-clients-table';

@Component({
  standalone: true,
  selector: 'app-admin-clients-page',
  imports: [PageComponent, Users01, Building05, UserCircle, AdminClientsTable],
  templateUrl: './admin-clients-page.html',
  styleUrl: './admin-clients-page.scss',
})
export class AdminClientsPage {
  private client = inject(ClientsClient);

  stats = signal<ClientStatsResponse | undefined>(undefined);

  constructor() {
    this._loadStats();
  }

  private _loadStats() {
    this._getStats().then((res) => {
      this.stats.set(res.result);
    });
  }

  private async _getStats() {
    return await firstValueFrom(this.client.getClientStats());
  }
}
